import { Button, Row, Typography } from "antd";
import { Booking } from "interfaces/booking";
import { useEffect } from "react";
import { useLoaderData, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setBackgroundColor } from "redux-context/page";
import { onClickCopy } from "helpers/copy-helper";
import { ReactComponent as CopyIcon } from "assets/images/copy-icon.svg";
import "../collabs/Collabs.scss";
// enum Page {
//   Welcome = "Welcome",
//   Certificate = "Certificate",
// }

const Welcome: React.FC = () => {
  // const [page, setPage] = useState(Page.Welcome);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { booking } = useLoaderData() as { booking: Booking };

  const onCLickShowCertificate = () => {
    navigate("/certificate", { state: { booking } });
  };

  const showLater = () => {
    navigate("/");
  };

  useEffect(() => {
    dispatch(setBackgroundColor("#e2f2dc"));
    return () => {
      dispatch(setBackgroundColor());
    };
  }, [dispatch]);

  return (
    <div
      className="page-full-screen fixed green book-detail collab-detail"
      style={{ overflow: "auto" }}
    >
      <>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <div>
            <Typography.Title level={3} className="heading-1-32-bold">
              Welcome and enjoy your experience at {booking?.venue?.name}!
            </Typography.Title>
            <Typography.Text className="subtitle-18-regular-poppins">
              Before you start, please carefully read the collab instructions.
            </Typography.Text>
          </div>

          <Row>
            <div
              className="briefing"
              style={{
                margin: "20px 0",
                borderRadius: 30,
                border: "1px solid rgba(29, 32, 35, 0.10)",
                background: "#fff",
              }}
            >
              <span className="title">Brief:</span>
              <Typography.Paragraph>
                {booking.collabDetails?.focusPoints}
              </Typography.Paragraph>
              <span className="title">Deliverables:</span>
              <ul>
                {booking?.deliverables?.map((item) => (
                  <li className="circle checkmark">{item}</li>
                ))}
              </ul>
              {booking?.collabDetails?.promotionOfferSummary && (
                <>
                  <span className="title">
                    Mention this offer to your followers:
                  </span>
                  <Typography.Paragraph style={{ display: "flex", gap: 6 }}>
                    {booking?.collabDetails?.promotionOfferSummary}
                  </Typography.Paragraph>
                </>
              )}
              {booking?.collabDetails?.promotionActionDm &&
                booking?.instagramAccount && (
                  <>
                    <span className="title">
                      To receive the offer they should DM @
                      {booking?.instagramAccount}:
                    </span>
                    <Typography.Paragraph
                      style={{ display: "flex", gap: 6 }}
                      onClick={() =>
                        onClickCopy(booking?.collabDetails?.promotionActionDm)
                      }
                    >
                      {booking?.collabDetails?.promotionActionDm}{" "}
                      <CopyIcon style={{ cursor: "pointer" }} />
                    </Typography.Paragraph>
                  </>
                )}

              {booking?.collabDetails?.promotionSwipeLink && (
                <>
                  <span className="title">
                    Add this swipe-up link to your story:
                  </span>
                  <Typography.Paragraph
                    style={{ display: "flex", gap: 6 }}
                    onClick={() =>
                      onClickCopy(booking?.collabDetails?.promotionSwipeLink)
                    }
                  >
                    {booking?.collabDetails?.promotionSwipeLink}{" "}
                    <CopyIcon style={{ cursor: "pointer" }} />
                  </Typography.Paragraph>
                </>
              )}
              {booking?.collabDetails?.promotionCaptionLink && (
                <>
                  <span className="title">
                    Use this caption for the swipe-up:
                  </span>
                  <Typography.Paragraph
                    style={{ display: "flex", gap: 6 }}
                    onClick={() =>
                      onClickCopy(booking?.collabDetails?.promotionCaptionLink)
                    }
                  >
                    {booking?.collabDetails?.promotionCaptionLink}{" "}
                    <CopyIcon style={{ cursor: "pointer" }} />
                  </Typography.Paragraph>
                </>
              )}
            </div>
          </Row>

          <Typography.Text
            className="subtitle-18-regular-poppins"
            style={{ color: "#1E3EFF" }}
          >
            The content is due within 5 days from now.
          </Typography.Text>
        </div>
        <div>
          <Button
            type="primary"
            size="large"
            shape="round"
            onClick={onCLickShowCertificate}
            style={{ marginTop: 24, width: "100%" }}
          >
            I agree, Start Experience
          </Button>
          <Button
            type="link"
            style={{ marginTop: 12, width: "100%", fontWeight: "bold" }}
            onClick={showLater}
          >
            Show later
          </Button>
        </div>
      </>
      {/* )} */}
    </div>
  );
};

export default Welcome;
